import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import CallSplitIcon from '@material-ui/icons/CallSplit'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import FontDownloadIcon from '@material-ui/icons/FontDownload'
import GetAppIcon from '@material-ui/icons/GetApp'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import AssignmentIcon from '@material-ui/icons/Assignment'
import CancelIcon from '@material-ui/icons/Cancel'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import SettingsIcon from '@material-ui/icons/Settings'
import ShareIcon from '@material-ui/icons/Share'
import SvgIcon from '@material-ui/core/SvgIcon'
import * as constants from '../../../constants'
import Word from '../../../containers/Common/Word'
import { WID } from '../../../constants/Language';
import { useContext } from 'react'
import { Auth0Context } from '../../../Parts/Auth0'


const styles = {
}

const RenjuBoardMenu = (props) => {
  const {
    classes,
    type,
    userType,
    anchorEl,
    clickedMenu,
    editMode,
    isAnalyzeMode,
    isMarkMode,
    handleOpenAnalyzeTab,
    handleClick,
    handleClose,
    handleExited,
    handleCloseBoard,
    handleAnalyzeMode,
    handleMarkMode,
    handleShareDialog,
    handleTweetDialog,
    handleDownloadImageDialog,
    handleGameInfoDialog,
    handlePuzzleInfoDialog,
    handleSettingsDialog,
  } = props

  const auth0Context = useContext(Auth0Context)
  var user = auth0Context.user

  return (
    <div>
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onExited={handleExited(clickedMenu)}
      >
        {type === constants.boardType.GAME_ANALYZE && (
        <MenuItem onClick={handleCloseBoard}>
          <ListItemIcon>
            <CancelIcon />
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.primary }} inset primary={<Word wid={WID.RENJU_BOARD_CARD_MENU.CLOSE}/>} />
        </MenuItem>          
        )}
        {type === constants.boardType.LIVE_GAME && (
        <MenuItem onClick={handleOpenAnalyzeTab}>
          <ListItemIcon>
            <OpenInNewIcon />
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.primary }} inset primary={<Word wid={WID.RENJU_BOARD_CARD_MENU.OPEN_ANALYZE_TAB}/>} />
        </MenuItem>          
        )}
        {!isAnalyzeMode && editMode === constants.editModeType.NORMAL && userType !== constants.userType.AUDIENCE && (
        <MenuItem onClick={handleAnalyzeMode}>
          <ListItemIcon>
            <CallSplitIcon/>
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.primary }} inset primary={<Word wid={WID.RENJU_BOARD_CARD_MENU.BRANCH}/>} />
        </MenuItem>
        )}
        {!isMarkMode && userType !== constants.userType.AUDIENCE && (
        <MenuItem onClick={handleMarkMode}>
          <ListItemIcon>
            <FontDownloadIcon />
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.primary }} inset primary={<Word wid={WID.RENJU_BOARD_CARD_MENU.MARK}/>} />
        </MenuItem>
        )}
        <MenuItem onClick={handleShareDialog}>
          <ListItemIcon>
            <ShareIcon />
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.primary }} inset primary={<Word wid={WID.RENJU_BOARD_CARD_MENU.SHARE}/>} />
        </MenuItem>
        {user !== null && user !== undefined && user.sub.match('twitter') && (
        <MenuItem onClick={() => handleTweetDialog(true)}>
          <ListItemIcon>
            <SvgIcon viewBox="-20 -20 140 140" >
              <path d="M31.45,90.64c37.74,0,58.37-31.27,58.37-58.38,0-.89,0-1.77-.06-2.65A41.86,41.86,0,0,0,100,19a41.19,41.19,0,0,1-11.78,3.23,20.6,20.6,0,0,0,9-11.35,41.11,41.11,0,0,1-13,5,20.54,20.54,0,0,0-35,18.71A58.25,58.25,0,0,1,7,13.12a20.53,20.53,0,0,0,6.35,27.39A20.29,20.29,0,0,1,4,37.94a2.44,2.44,0,0,0,0,.27A20.53,20.53,0,0,0,20.47,58.32a20.49,20.49,0,0,1-9.26.35A20.54,20.54,0,0,0,30.38,72.92,41.21,41.21,0,0,1,4.89,81.7,41.69,41.69,0,0,1,0,81.42a58.07,58.07,0,0,0,31.45,9.22" />
            </SvgIcon>
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.primary }} inset primary={<Word wid={WID.RENJU_BOARD_CARD_MENU.TWEET}/>} />
        </MenuItem>
        )}
        <MenuItem onClick={() => handleDownloadImageDialog(true)}>
          <ListItemIcon>
            <GetAppIcon />
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.primary }} inset primary={<Word wid={WID.RENJU_BOARD_CARD_MENU.DOWNLOAD_IMAGE}/>} />
        </MenuItem>
        {editMode === constants.editModeType.NORMAL && userType !== constants.userType.AUDIENCE && (
        <MenuItem onClick={handleGameInfoDialog}>
          <ListItemIcon className={classes.icon}>
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.primary }} inset primary={<Word wid={WID.RENJU_BOARD_CARD_MENU.GAME_INFO_SETTINGS}/>} />
        </MenuItem>
        )}
        {editMode === constants.editModeType.PUZZLE && (
        <MenuItem onClick={handlePuzzleInfoDialog}>
          <ListItemIcon className={classes.icon}>
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.primary }} inset primary={<Word wid={WID.RENJU_BOARD_CARD_MENU.PUZZLE_INFO_SETTINGS}/>} />
        </MenuItem>
        )}
        <MenuItem onClick={handleSettingsDialog}>
          <ListItemIcon className={classes.icon}>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.primary }} inset primary={<Word wid={WID.RENJU_BOARD_CARD_MENU.SETTINGS}/>} />
        </MenuItem>
      </Menu>
    </div>
  )
}

export default withStyles(styles)(RenjuBoardMenu)



// WEBPACK FOOTER //
// ./src/components/Common/RenjuBoardCard/RenjuBoardMenu.js